/* istanbul ignore file */
import ScrollToTop from './ScrollToTop';

export default ScrollToTop;
